import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { toast } from "sonner";

// shadcn/ui's standard className combiner.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Push `text` to the OS clipboard, with a window.prompt fallback for
 * insecure origins where navigator.clipboard is unavailable.
 */
export function copyToClipboard(text: string, promptLabel = "Copy:"): void {
  const cb = navigator.clipboard;
  if (cb) {
    cb.writeText(text).then(
      () => toast.success("Copied to clipboard"),
      () => {
        window.prompt(promptLabel, text);
      },
    );
    return;
  }
  window.prompt(promptLabel, text);
}
